<template>
  <div :class="['navbar', productCenter ? 'bg_white' : '']">
    <router-link to="/">
    <!-- <svg-icon class="icon" iconName="logo_w" /> -->
      <img :class="['logo', productCenter ? 'logo_back' : '']" :src="productCenter ? require(`@/assets/logo_w-m.svg`) : require(`@/assets/logo_b.png`)" alt="">
    </router-link>

    <svg-icon
      iconName="more"
      @click="showDrawer = true"
      class="tool"
      v-if="!showDrawer"
    />
    <i
      class="el-icon-close tool"
      @click="onClose"
      v-else
    />

    <el-drawer
      :visible.sync="showDrawer"
      :with-header="false"
      @closed="onClose"
      direction="ttb"
      :append-to-body="true"
      size="100%"
      :modal="false"
    >
      <el-menu
        background-color="#ffffff"
        text-color="#333333"
      >
        <menu-item :list="menuData" @jump="onClose" />
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
import menuData from './menu.json'
import MenuItem from './menu-item'

export default {
  name: 'MobileHeader',
  components: { MenuItem },
  data() {
    return {
      showDrawer: false,
      menuData,
      productCenter: false
    }
  },
  watch: {
    $route: {
      handler(val) {
        const urlArr = val.path.split('/')
        if (urlArr.indexOf('product') > -1) {
          this.productCenter = true
          // this.menuData = menuData.slice(2, menuData.length)
          const list = []
          menuData[2].subMenu.map(item => {
            const temp = JSON.parse(JSON.stringify(item))
            // 移动端：开放平台·产品中心页面下，navbar菜单不显示“开放平台·产品中心”菜单项，导致路由少了“/open”，这里补上
            temp.path = '/open' + item.path
            list.push(temp)
          })
          list.push(menuData[3])
          list.push(menuData[4])
          this.menuData = list
        } else {
          this.productCenter = false
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    onClose() {
      this.showDrawer = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .navbar {
    @include flexBox;
    @include px2rem(height, $mobileNavbarH);
    @include px2rem(padding, 0 30px);
    justify-content: space-between;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1001;
  }
  .logo {
    display: block;
    @include px2rem(width, 210px);
  }
  .logo_back {
    @include px2rem(width, 276px);
    @include px2rem(height, 40px);
  }
  .tool {
    @include px2rem(width, 40px);
    @include px2rem(height, 40px);
    @include px2rem(font-size, 42px);
    color: #000;
  }
  .bg_white {
    // 进入开放平台-产品中心样式
    background: #FFFFFF!important;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
  }

  /deep/ .el-menu > div + a .el-menu-item{
  font-weight: 700;
}
  /deep/ .el-menu:first-child {
    border: 0;
    @include px2rem(margin-left, 30px);

    .el-submenu__icon-arrow {
      font-weight: 800;
      @include px2rem(font-size, 36px);
    }
    .el-menu-item, .el-submenu__title {
      @include px2rem(font-size, 30px);
      border-bottom: 1px solid rgba(213, 213, 213, 0.48);
    }
    .el-menu-item, .el-submenu__title {
      padding-left: 0 !important;
      background-color: #fff !important;
    }
    .el-submenu .el-menu {
      background-color: #ffffff;
      .el-submenu__title, .el-menu-item {
        @include px2rem(font-size, 26px);
        color: #666666 !important;
        @include px2rem(padding-left, 50px !important);
      }
      .el-menu {
        .el-menu-item {
          @include px2rem(padding-left, 100px !important);
        }
      }
    }
    .el-submenu.is-opened {
      background-color: #fff !important;
      > .el-submenu__title {
        color: $color-primary !important;

      }
    }
  }
  :global(.el-drawer__wrapper), :global(.el-dialog__wrapper) {
    z-index: 1000 !important;

    /deep/ .el-drawer__header {
      display: none;
    }
    /deep/ .el-drawer__body {
      background: #ffffff;
      @include px2rem(padding-top, $mobileNavbarH);
      overflow: auto;
      color: #333333;
    }
  }
</style>
